import { MobileDataInterface } from 'mobile';

export const onOpenLockAdministration = (object: MobileDataInterface<{ lock_id: string }>) => {
    // For IOS
    window.webkit && window.webkit.messageHandlers.onOpenLockAdministration.postMessage(object);
    // For Android
    window.WebAppInterface && window.WebAppInterface?.onOpenLockAdministration(JSON.stringify(object));
};
